module.exports = __webpack_public_path__ + "img/jishu.0f539a6b.jpg";